/*
 * Copyright © 2026. Legalbird eine Marke der Legalbird GmbH
 */

import { useState } from "react";
import { Box, Button, Stack, Typography } from "@mui/material";
import StyleguideView from "@/src/styleguide/components/StyleguideView/StyleguideView";
import { Cookie, Login } from "@mui/icons-material";
import DialogModal from "@/src/components/DialogModal/DialogModal";
import CookieModal from "@/src/components/CookieBanner/CookieModal";
import { useAuthDialog } from "@/src/provider/AuthDialog/AuthDialogProvider";

export default function DialogStyleguide() {
  const [activeModal, setActiveModal] = useState<"dialog" | "cookie" | "default" | null>(null);
  const { setView } = useAuthDialog();

  const handleClose = () => setActiveModal(null);

  return (
    <>
      <StyleguideView title={"Default"}>
        <Box>
          <Button variant={"contained"} onClick={() => setActiveModal("default")}>
            Open Dialog
          </Button>
        </Box>
      </StyleguideView>
      <StyleguideView title={"Variant (Clean)"}>
        <Stack direction={"column"} spacing={"1.5rem"}>
          <Box>
            <Button variant={"contained"} onClick={() => setActiveModal("dialog")}>
              Open Dialog variant
            </Button>
          </Box>
          <Box>
            <Button variant={"contained"} onClick={() => setActiveModal("cookie")} endIcon={<Cookie />}>
              Open Cookie Settings
            </Button>
          </Box>
          <Box>
            <Button variant={"contained"} onClick={() => setView({ type: "login" })} endIcon={<Login />}>
              Open Login
            </Button>
          </Box>
        </Stack>
      </StyleguideView>

      <DialogModal
        open={activeModal === "default"}
        onClose={handleClose}
        title={"Informationen zur Echtheit der Bewertungen"}
        actions={
          <Stack direction={"row"} spacing={"1rem"}>
            <Button variant="outlined">Cancel</Button>
            <Button variant="contained">Continue</Button>
          </Stack>
        }
        maxWidth={"md"}
      >
        <Typography variant="body2">
          Uns ist Transparenz wichtig – gerade als Kanzlei. Alle auf dieser Webseite dargestellten Mandantenstimmen sind echte, verifizierte Rückmeldungen, die
          nach Abschluss des jeweiligen Verfahrens im Rahmen unserer internen Mandantenbefragungen oder in öffentlichen Bewertungsportalen abgegeben wurden. Zum
          Schutz der Privatsphäre unserer Mandanten, zur Einhaltung der DSGVO und zur Wahrung der anwaltlichen Schweigepflicht veröffentlichen wir diese
          Rückmeldungen in anonymisierter Form ohne Nennung von Personenbezug.Jede dieser Bewertungen wurde vor der Veröffentlichung manuell durch uns auf ihre
          Echtheit geprüft und ist intern einem realen, erfolgreich abgeschlossenen Mandat zugeordnet.
        </Typography>
      </DialogModal>

      <DialogModal
        open={activeModal === "dialog"}
        onClose={handleClose}
        title={"Informationen zur Echtheit der Bewertungen"}
        actions={
          <Stack direction={"row"} spacing={"1rem"}>
            <Button variant="outlined">Cancel</Button>
            <Button variant="contained">Continue</Button>
          </Stack>
        }
        variant={"clean"}
      >
        <Typography variant="body2">
          Uns ist Transparenz wichtig – gerade als Kanzlei. Alle auf dieser Webseite dargestellten Mandantenstimmen sind echte, verifizierte Rückmeldungen, die
          nach Abschluss des jeweiligen Verfahrens im Rahmen unserer internen Mandantenbefragungen oder in öffentlichen Bewertungsportalen abgegeben wurden. Zum
          Schutz der Privatsphäre unserer Mandanten, zur Einhaltung der DSGVO und zur Wahrung der anwaltlichen Schweigepflicht veröffentlichen wir diese
          Rückmeldungen in anonymisierter Form ohne Nennung von Personenbezug.Jede dieser Bewertungen wurde vor der Veröffentlichung manuell durch uns auf ihre
          Echtheit geprüft und ist intern einem realen, erfolgreich abgeschlossenen Mandat zugeordnet.
        </Typography>
      </DialogModal>

      <CookieModal open={activeModal === "cookie"} setIsConfigureOpen={() => handleClose()} isSelectionMade={false} setIsSelectionMade={() => false} />
    </>
  );
}
